import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormGroup, FormsModule } from "@angular/forms";
import { Table, TableModule, TableRowSelectEvent } from "primeng/table";

import * as FileSaver from "file-saver";
import {
  PurchaseOrderHeader,
  PurchaseOrderLineSummary,
} from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { SelectModule } from "primeng/select";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DatePicker, DatePickerModule } from "primeng/datepicker";
import {
  computeMinDate,
  toDateOrNull,
} from "../../../../core/utilities/mindate-function";

@Component({
  selector: "jni-line-items",
  templateUrl: "./line-items.component.html",
  imports: [
    CommonModule,
    DatePickerModule,
    FormsModule,
    TableModule,
    HidedynamicsdatePipe,
    SelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
  styleUrls: ["./line-items.component.scss"],
  // providers: [NgbPopoverConfig]
})
export class LineItemsComponent {
  @ViewChild("dt") table!: Table;

  @Input()
  parent!: FormGroup;

  @Input() purchaseOrderHeader: PurchaseOrderHeader | undefined;
  @Input() purchaseOrderLineList: PurchaseOrderLineSummary[] = [];
  @Input() purchaseOrderStatus!: string;

  @Output() lineSelected = new EventEmitter<PurchaseOrderLineSummary>();
  @Output() createLine = new EventEmitter<boolean>();
  @Output() dropEvent = new EventEmitter<PurchaseOrderLineSummary[]>();
  @Output() copyEvent = new EventEmitter<PurchaseOrderLineSummary[]>();
  @Output() copyLinesEvent = new EventEmitter<PurchaseOrderLineSummary[]>();
  @Output() updateLine = new EventEmitter();
  @Output() printLineEvent = new EventEmitter<boolean>();

  @Input() currencyConversion!: ExchangeRatesDto;
  @Input() releasedProductsList: ReleasedProduct[] = [];
  @Output() gridSaveAndUpdateEvent =
    new EventEmitter<PurchaseOrderLineSummary>();
  @Output() refrestDataEvent = new EventEmitter();
  showSmallLoader = false;
  checkAllCheckBoxChecked = false;
  releasedProductsStrList: string[] = [];
  constructor(private _toastr: JniToastrService) {}

  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";

  editItem!: PurchaseOrderLineSummary;
  selectedLines!: PurchaseOrderLineSummary | null;
  selectedLinesForCheckbox: PurchaseOrderLineSummary[] = [];
  shipMindate!: Date;
  inHandMindate!: Date;
  // toggleDropdown(mydrop: any) {
  //   mydrop.open();
  // }

  get linesArray() {
    return (this.parent.get("linesArray") as FormArray).controls;
  }
  rowSelected(event: TableRowSelectEvent) {
    this.lineSelected.emit(event.data);
  }
  createNewLine() {
    this.selectedLinesForCheckbox = [];
    this.createLine.emit(true);
  }
  uncheckAll() {
    this.selectedLinesForCheckbox = [];
  }
  onDrop() {
    if (this.selectedLinesForCheckbox?.length) {
      const filtered = this.selectedLinesForCheckbox.filter(function (
        ele: PurchaseOrderLineSummary
      ) {
        return ele.id !== undefined;
      });
      if (filtered.length > 0) {
        this.dropEvent.emit(filtered);
        this.dropEvent.emit(filtered);
      }
      this.checkAllCheckBoxChecked = false;
    }
  }
  onCopy() {
    if (this.selectedLinesForCheckbox?.length) {
      this.copyEvent.emit(this.selectedLinesForCheckbox);
      this.copyEvent.emit(this.selectedLinesForCheckbox);
    }
  }

  onRowEditInit(event: PurchaseOrderLineSummary) {
    this.editItem = event;
    this.releasedProductsStrList = Object.values(this.releasedProductsList)
      .map(obj => obj.itemNumberD365)
      .filter((x): x is string => x !== null);
  }

  onRowEditSave(salesOrderLine: PurchaseOrderLineSummary) {
    if (!salesOrderLine.externalItemNumberD365) {
      this._toastr.error("Error", "Vendor Sku required");
      //this.table.value.splice(this.table.value?.length - 1, 1);
      this.refrestDataEvent.emit();
      return;
    }
    if (!salesOrderLine.itemNumberD365) {
      this._toastr.error("Error", "Category required");
      //this.table.value.splice(this.table.value?.length - 1, 1);
      this.refrestDataEvent.emit();
      return;
    }
    if (!salesOrderLine.orderedPurchaseQuantityD365) {
      this._toastr.error("Error", "Quantity required");
      //this.table.value.splice(this.table.value?.length - 1, 1);
      this.refrestDataEvent.emit();
      return;
    }
    if (!salesOrderLine.requestedDeliveryDateD365) {
      this._toastr.error("Error", "In Hand date is required");
      this.refrestDataEvent.emit();
      return;
    }

    const shipDateHeader = salesOrderLine.requestedShippingDateD365;
    const inHandDateHeader = salesOrderLine.requestedDeliveryDateD365;
    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._toastr.error(
          "Error",
          "Inhands date must greater and equal to ship date"
        );
        this.refrestDataEvent.emit();
        return;
      }
    }
    if (!inHandDateHeader) {
      this._toastr.error("Error", "In hand date required");
      this.refrestDataEvent.emit();
      return;
    }

    if (!salesOrderLine.id) {
      this.gridSaveAndUpdateEvent.emit(salesOrderLine);
    } else {
      this.gridSaveAndUpdateEvent.emit(salesOrderLine);
    }
  }

  onRowEditCancel(event: PurchaseOrderLineSummary) {
    this.editItem = event;
    this.refrestDataEvent.emit();
    // if (!event.id) {
    //   this.table.value.splice(this.table.value?.length - 1, 1);
    // }
  }

  addNewLine() {
    const sortedTable = this.table.value.sort((a, b) => {
      if (a.lineNumberD365 < b.lineNumberD365) {
        return -1;
      }
      if (a.lineNumberD365 > b.lineNumberD365) {
        return 1;
      }
      return 0;
    });
    const lastObject = sortedTable[sortedTable?.length - 1];
    if (lastObject) {
      const lineObject: PurchaseOrderLineSummary = {
        lineNumberD365: lastObject.lineNumberD365 + 1,
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: null,
        requestedShippingDateD365: "",
        requestedDeliveryDateD365: "",
        rsmFirmD365: "false",
        purchasePriceD365: null,
        lineAmountD365: null,
        netConversion: "",
        netConversionTotal: "",
        lineDescriptionD365: "",
        factoryNotesD365: "",
        rates: "",
        itemNumberD365: null,
        deliveryModeIdD365: null,
        modifiedBy1D365: null,
        modifiedDateTime1D365: null,
        createdBy1D365: null,
        createdDateTime1D365: null,
        purchaseOrderNumberD365: null,
        lineRecIdD365: null,
        projectCategoryIdD365: null,
        purchaseUnitSymbolD365: null,
        purchaseOrderLineStatusD365: null,
        workflowStateD365: null,
        trackableD365: null,
        status: null,
        inventTransId: null,
        sequence: null,
        portalKeyD365: null,
        freightAccountNumD365: null,
        currencyCodeD365: null,
        statusCodeD365: null,
        messageD365: null,
        isHighlighted: false,
        finalPoD365: null,
        excludedD365: null,
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
        id: 0,
      };
      this.purchaseOrderLineList.push(lineObject);
    } else {
      const lineObject: PurchaseOrderLineSummary = {
        lineNumberD365: 1,
        externalItemNumberD365: "",
        orderedPurchaseQuantityD365: null,
        requestedShippingDateD365: "",
        requestedDeliveryDateD365: "",
        rsmFirmD365: "false",
        purchasePriceD365: null,
        lineAmountD365: null,
        netConversion: "",
        netConversionTotal: "",
        lineDescriptionD365: "",
        factoryNotesD365: "",
        rates: "",
        itemNumberD365: null,
        deliveryModeIdD365: null,
        modifiedBy1D365: null,
        modifiedDateTime1D365: null,
        createdBy1D365: null,
        createdDateTime1D365: null,
        purchaseOrderNumberD365: null,
        lineRecIdD365: null,
        projectCategoryIdD365: null,
        purchaseUnitSymbolD365: null,
        purchaseOrderLineStatusD365: null,
        workflowStateD365: null,
        trackableD365: null,
        status: null,
        inventTransId: null,
        sequence: null,
        portalKeyD365: null,
        freightAccountNumD365: null,
        currencyCodeD365: null,
        statusCodeD365: null,
        messageD365: null,
        isHighlighted: false,
        finalPoD365: null,
        excludedD365: null,
        createdDate: "",
        createdBy: "",
        lastModifiedDate: null,
        lastModifiedBy: null,
        isActive: false,
        id: 0,
      };
      this.purchaseOrderLineList.push(lineObject);
    }

    this.table.initRowEdit(this.table.value[this.table.value?.length - 1]);
  }

  onNetConversion(event: Event, lineObject: PurchaseOrderLineSummary) {
    const target = event.target as HTMLInputElement;
    let netRate = target.value.replace(/[^0-9.]/g, "");
    const regExp = /^(\d+(\.\d+)?)$/;
    const revenue = regExp.test(netRate) ? "valid" : "invalid";
    if (revenue === "valid") {
      netRate = netRate.substring(0, 9);
      lineObject.purchasePriceD365 = parseFloat(netRate);
      if (netRate) {
        if (this.currencyConversion) {
          if (this.currencyConversion.Rate != 0) {
            this.netReteAfterConversion =
              parseFloat(netRate) * this.currencyConversion?.Rate;
            if (this.netReteAfterConversion.toString() != "") {
              this.netConvertToUsd = this.netReteAfterConversion.toString();
              lineObject.netConversion = this.netConvertToUsd;
            }
          }
        }

        this.patchValueInTotalNet(
          netRate,
          this.netReteAfterConversion.toString(),
          (
            lineObject!.orderedPurchaseQuantityD365! as unknown as string
          ).toString() ?? "",
          lineObject
        );
      }
    } else {
      lineObject.purchasePriceD365 = 0;
      lineObject.lineAmountD365 = 0;
      lineObject.netConversion = "";
      lineObject.netConversionTotal = "";
    }
  }

  patchValueInTotalNet(
    net: string,
    convertedNet: string,
    lineQuantity: string,
    lineObject: PurchaseOrderLineSummary
  ) {
    const quantity = lineQuantity;
    if (quantity) {
      const netprice = parseFloat(net) * parseInt(quantity);
      this.netTotalPrice = netprice.toString();
      lineObject.lineAmountD365 = parseFloat(this.netTotalPrice);
      const netPriceCon =
        parseFloat(convertedNet == "" ? "0" : convertedNet) *
        parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      lineObject.netConversionTotal = this.netTotalPriceConverted;
    }
  }

  calculateQuantity(event: Event, salesOrderLine: PurchaseOrderLineSummary) {
    //const quantity = event;
    const target = event.target as HTMLInputElement;
    let quantity = target.value.replace(/[^-0-9]/g, "");
    quantity = quantity.substring(0, 5);
    if (quantity) {
      salesOrderLine.orderedPurchaseQuantityD365 = parseInt(quantity);
      const netPrice = salesOrderLine.purchasePriceD365;
      if (netPrice) {
        //netPrice = netPrice.replace(/[^a-zA-Z0-9.]/g, '');
        const convertedNetPrice = salesOrderLine.netConversion;
        this.patchValueInTotalNet(
          (netPrice as unknown as string).toString(),
          convertedNetPrice ?? "",
          (
            salesOrderLine.orderedPurchaseQuantityD365 as unknown as string
          ).toString() ?? "",
          salesOrderLine
        );
      }
    } else {
      salesOrderLine.orderedPurchaseQuantityD365 = parseInt(quantity);
    }
  }

  inHandDateChange(event: Event, samplepoLineItems: PurchaseOrderLineSummary) {
    const eventTarget = event.target as HTMLInputElement;
    samplepoLineItems.requestedDeliveryDateD365 = eventTarget.value;
  }

  // shipDateChange(event: Event, samplepoLineItems: PurchaseOrderLineSummary) {
  //   const eventTarget = event.target as HTMLInputElement;
  //   samplepoLineItems.requestedShippingDateD365 = eventTarget.value;
  // }

  getCurrencyConvertionCode(currency: string) {
    if (currency) {
      return currency;
    } else {
      return "USD";
    }
  }

  editLine(id: number) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.id === id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
    this.updateLine.emit();
  }
  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  exportExcel() {
    if (this.selectedLinesForCheckbox?.length > 0) {
      this.exportExcelForFilterData(this.selectedLinesForCheckbox);
    } else {
      this.exportExcelForFilterData(this.purchaseOrderLineList);
    }
  }

  exportExcelForFilterData(filterclientlist: PurchaseOrderLineSummary[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Vendor SKU"]: datum.externalItemNumberD365,
        ["Description"]: datum.lineDescriptionD365,
        ["Category"]: datum.itemNumberD365,
        ["Ship Date"]: new Date(datum.requestedShippingDateD365 ?? ""),
        ["Inhands Date"]: new Date(datum.requestedDeliveryDateD365 ?? ""),
        ["Firm"]: datum.rsmFirmD365,
        ["Net Amount"]: datum.purchasePriceD365,
        ["Net Total"]: datum.lineAmountD365,
        ["Factory Notes"]: datum.factoryNotesD365,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "SamplePOList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onCopyLines() {
    const SelectedPoLines = this.selectedLinesForCheckbox;
    this.selectedLinesForCheckbox = [];
    this.checkAllCheckBoxChecked = false;
    this.copyLinesEvent.emit(SelectedPoLines);
  }

  onLineRedirect() {
    this.updateLine.emit();
  }
  checkLineItems() {
    const soStoppedList = this.releasedProductsList.map(
      item => item.itemNumberD365
    );
    const filter = this.purchaseOrderLineList.filter(item =>
      soStoppedList.includes(item.itemNumberD365 ?? "")
    );
    if (filter.length === this.purchaseOrderLineList.length) {
      return { isRestricted: false, items: [] };
    } else {
      const diff = this.purchaseOrderLineList.filter(
        item => !filter.includes(item)
      );
      return { isRestricted: true, items: diff };
    }
  }

  printLine() {
    const checkItems = this.checkLineItems();
    if (checkItems.isRestricted) {
      this._toastr.error(
        "Error",
        `Inactive item(s) ${checkItems.items[0].itemNumberD365}. Select an alternate item and try again.`
      );
      return;
    }
    this.printLineEvent.emit(true);
  }

  isStatusSubmitted() {
    if (
      this.purchaseOrderHeader &&
      (this.purchaseOrderHeader!.status! as string).toLowerCase() ===
        "submitted"
    ) {
      return true;
    } else {
      return false;
    }
  }

  selectAllLinesCheckbox(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget?.checked) {
      this.purchaseOrderLineList.forEach(x => {
        x.isHighlighted = true;
      });
      this.selectedLinesForCheckbox = this.purchaseOrderLineList;
    } else {
      this.purchaseOrderLineList.forEach(x => {
        x.isHighlighted = false;
      });
      this.selectedLinesForCheckbox = [];
    }
  }

  lineItemsCheckboxChanged(line: PurchaseOrderLineSummary, event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    if (eventTarget?.checked) {
      if (line) {
        line.isHighlighted = true;
        this.selectedLinesForCheckbox.push(line);
        this.lineSelected.emit(line);
        this.selectedLines = null;
      }
    } else {
      if (line) {
        line.isHighlighted = false;
        this.selectedLinesForCheckbox = this.selectedLinesForCheckbox.filter(
          x => x.id !== line.id
        );
      }
    }
  }

  styleObject(value: boolean) {
    if (value) {
      return { background: "#4696ec !important", color: "#f7faff !important" };
    }
    return {};
  }

  handleKeyDown(event: Event, dp: DatePicker): void {
    if (
      event instanceof InputEvent &&
      event.inputType === "insertText" &&
      event.data === " "
    ) {
      event.preventDefault();
      dp.overlayVisible = true;
      return;
    }
  }

  setShipMinDate(line: PurchaseOrderLineSummary) {
    this.shipMindate = computeMinDate(line.requestedShippingDateD365);
  }

  setInHandMinDate(line: PurchaseOrderLineSummary) {
    let candidate: Date | null = null;
    const shipOrgDate = toDateOrNull(line.requestedShippingDateD365);
    const inHandOrgDate = toDateOrNull(line.requestedDeliveryDateD365);
    if (shipOrgDate && inHandOrgDate) {
      candidate =
        new Date(
          inHandOrgDate.getFullYear(),
          inHandOrgDate.getMonth(),
          inHandOrgDate.getDate()
        ) <
        new Date(
          shipOrgDate.getFullYear(),
          shipOrgDate.getMonth(),
          shipOrgDate.getDate()
        )
          ? inHandOrgDate
          : shipOrgDate;
    } else {
      candidate = shipOrgDate ?? inHandOrgDate ?? null;
    }
    this.inHandMindate = computeMinDate(candidate, false);
  }
}
